{
  "messages": {
    "rescheduledOnce": "Reprogramado una vez",
    "rescheduledTwice": "Reprogramado dos veces",
    "rescheduledCountTimes": "Reprogramado {count} veces"
  }
}
